import { Grid, GridProps } from "@chakra-ui/react";
import {
  LabeledValueContextProvider,
  LabeledValueContextProviderProps,
} from "components/Shared/LabeledValue";

export const GRID_PROPS: Pick<
  GridProps,
  "gridTemplateColumns" | "gridColumnGap" | "gridRowGap"
> = {
  gridTemplateColumns: "repeat(auto-fill, minmax(12rem, 1fr))",
  gridColumnGap: 3,
  gridRowGap: 4,
};

type Props = LabeledValueContextProviderProps & GridProps;

export default function LabeledValueGrid({
  children,
  isLoaded,
  labelProps,
  statProps,
  valueProps,
  ...rest
}: Props) {
  return (
    <LabeledValueContextProvider
      {...{ isLoaded, labelProps, valueProps }}
      statProps={{ p: 0, ...statProps }}
    >
      <Grid {...GRID_PROPS} {...rest}>
        {children}
      </Grid>
    </LabeledValueContextProvider>
  );
}
